var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('i',{staticClass:"fa fa-clock-o fa-fw mr-2"}),_vm._v(_vm._s(_vm.startTime)+" - "+_vm._s(_vm.endTime)),_c('i',{staticClass:"fa fa-calendar-o fa-fw ml-4 mr-2"}),_vm._v(_vm._s(_vm.date)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }